module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#filter",
      toString: function () {
        return this.url;
      }
    }